import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export const useOpportunityContactsMutation = ({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (data: Api.IProjectedContact[]) => void;
} = {}) => {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: ({
			filterRequest,
			impersonationContext,
			boardId,
		}: {
			filterRequest: Api.IOpportunitySearchRequest;
			impersonationContext?: Api.IImpersonationContext;
			boardId: string;
		}) => {
			return userSession.webServiceHelper.callAsync<Api.IProjectedContact[]>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: `board/${boardId}/contacts`,
				}),
				'POST',
				filterRequest
			);
		},
		onError,
		onSuccess,
	});
};
